import VisibilityController from "../visibility-controller.js";

class VisibilityMultiController extends VisibilityController {
    constructor(controllers) {
        super();
        this._controllers = Object.assign({}, controllers);
    }

    setVisible(object, visible) {
        for (const key in this._controllers) {
            this._controllers[key].setVisible(object.objects[key], visible);
        }
    }
}

export default VisibilityMultiController;
